import { render, staticRenderFns } from "./Gard.vue?vue&type=template&id=52f32769"
import script from "./Gard.vue?vue&type=script&lang=js"
export * from "./Gard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports